module.exports = __webpack_public_path__ + "static/media/20_lodha.dcbf8fe6.svg";